import { DateTime } from 'luxon'
import { StatusChipsState } from '@labrav/react-components/lib/@types/v2/components/StatusChips'

import { SubscriptionStatusValue } from '../modules/subscription/reducer'

export const getStatusAndLabelForSubscription = (
  statusUpdate: SubscriptionStatusValue,
  expiryDate?: string,
  now: () => DateTime = DateTime.now,
  {
    treatPastExpiryAsExpired = false,
  }: { treatPastExpiryAsExpired?: boolean } = {}
) => {
  if (statusUpdate === SubscriptionStatusValue.SUBSCRIPTION_SUCCESS) {
    if (expiryDate) {
      const dayDiff = Math.ceil(
        DateTime.fromISO(expiryDate).diff(now(), 'days').days
      )
      if (treatPastExpiryAsExpired && dayDiff <= 0) {
        return { status: 'error' as StatusChipsState, label: 'Expired' }
      }
      if (dayDiff > 0 && dayDiff <= 90) {
        return { status: 'warning' as StatusChipsState, label: 'Expiring Soon' }
      }
      return { status: 'success' as StatusChipsState, label: 'Active' }
    }
    return { status: 'success' as StatusChipsState, label: 'Active' }
  }
  if (statusUpdate === SubscriptionStatusValue.UNSUBSCRIBE_PENDING) {
    return { status: 'warning' as StatusChipsState, label: 'Expiring Soon' }
  }
  if (statusUpdate === SubscriptionStatusValue.UNSUBSCRIBE_SUCCESS) {
    return { status: 'error' as StatusChipsState, label: 'Expired' }
  }
  if (statusUpdate === SubscriptionStatusValue.SUBSCRIPTION_FAIL) {
    return { status: 'error' as StatusChipsState, label: 'Subscription Failed' }
  }
  if (statusUpdate === SubscriptionStatusValue.SUBSCRIPTION_PENDING) {
    return { status: 'warning' as StatusChipsState, label: 'Subscribe Pending' }
  }
  return { status: 'error' as StatusChipsState, label: 'Expired' }
}
